// ActiveChips — renders the row of "Active: site-IAD12 ×" pills under the
// filter bar (mockup lines 2627–2635). Each chip carries a remove handler
// the parent uses to mutate the underlying URL state.

import "./Audit.css";

export interface ActiveChip {
  /** Stable id; combination of axis + value so React can key on it. */
  id: string;
  label: string;
  /** Optional axis-specific styling — date chips render in a different tone. */
  variant?: "default" | "date";
  onRemove: () => void;
}

export interface ActiveChipsProps {
  chips: ActiveChip[];
}

export function ActiveChips({ chips }: ActiveChipsProps): JSX.Element | null {
  if (chips.length === 0) return null;
  return (
    <div className="rb-audit__chips" role="list" aria-label="Active filters">
      <span className="rb-audit__chips-label">Active:</span>
      {chips.map((c) => (
        <span
          key={c.id}
          role="listitem"
          className={
            c.variant === "date"
              ? "rb-audit__chip rb-audit__chip--date"
              : "rb-audit__chip"
          }
        >
          {c.label}
          <button
            type="button"
            className="rb-audit__chip-x"
            onClick={c.onRemove}
            aria-label={`Remove filter ${c.label}`}
            title={`Remove ${c.label}`}
          >
            ×
          </button>
        </span>
      ))}
    </div>
  );
}
